import LoginForm from "../../components/Login/LoginForm";

export default function LoginPage({ onLogin }) {
  return <LoginForm onLogin={onLogin} />;
}